export enum TagCategoryTypeEnum {
  CRM = 1,
  PLAYER_CARD = 2,
  GAMIFICATION = 3,
}
